"use strict";

angular.module("customer")
.directive("header", function() {
    return {
        templateUrl: require("./header.html"),
        controller: HeaderController,
        controllerAs: "headerCtrl"
    };
});

function HeaderController(
    $window, $rootScope, $scope, $state, $stateParams, $cordovaBarcodeScanner, $cookies, gettextCatalog, UserService,
    appConfig, FlashBag, ProductCategoriesService, PreferredService, PromotionFilterService,
    IS_MOBILE, IS_MOBILE_APP, CUSTOMER_TYPE
) {
    var _this = this;

    $scope.isMobile = IS_MOBILE;
    $scope.isMobileApp = IS_MOBILE_APP;
    $scope.defaultEmail = null;
    $scope.groupInvite = $stateParams.groupInvite;
    $scope.isCustomerTypeBusiness = true;
    $scope.searchInputMode = "text";
    $scope.useQuickOrder = false;

    $scope.searchTypes = [
        {id: "stocks", label: "Products", translationExtraction: gettextCatalog.getString("Products"), hasFilter: true},
        {id: "vendors", label: "Vendors", translationExtraction: gettextCatalog.getString("Vendors"), hasFilter: true},
        {id: "userManagementList", label: "Users", translationExtraction: gettextCatalog.getString("Users")},
        {id: "customer-listing", label: "Customers", translationExtraction: gettextCatalog.getString("Customers")},
        {
            id: "partnership-listing",
            label: "Partnerships",
            translationExtraction: gettextCatalog.getString("Partnerships")
        },
        {id: "myOrders", label: "Orders", translationExtraction: gettextCatalog.getString("Orders")},
        {id: "orderTemplateList", label: "Templates", translationExtraction: gettextCatalog.getString("Templates")},
        {id: "invoiceList", label: "Invoices", translationExtraction: gettextCatalog.getString("Invoices")},
        {id: "paymentList", label: "Payments", translationExtraction: gettextCatalog.getString("Payments")},
        {
            id: "goodsReceiptList",
            label: "Goods Receipts",
            translationExtraction: gettextCatalog.getString("Goods Receipts")
        },
        {
            id: "goodsReceiptDetails",
            label: "Goods Receipt Products",
            translationExtraction: gettextCatalog.getString("Goods Receipt Products"),
            live: true
        },
        {
            id: "goodsTransferList",
            label: "Goods Transfers",
            translationExtraction: gettextCatalog.getString("Goods Transfers")
        },
        {
            id: "goodsTransferDetails",
            label: "Goods Transfer Products",
            translationExtraction: gettextCatalog.getString("Goods Transfer Products"),
            live: true
        },
        {
            id: "orderConsolidation",
            label: "Order Consolidation",
            translationExtraction: gettextCatalog.getString("Order Consolidation")
        }
    ];

    $scope.search = {
        term: $stateParams.search || null,
        section: $scope.searchTypes[0]
    };
    $scope.selectedCategories = [];

    angular.element(document).on("click", "#mobile-nav .navbar-nav", function() {
        angular.element("#mobile-nav").collapse("hide");
    });

    this.isUserCustomerListing = function() {
        return $state.current.name === "customer-listing" || $state.current.name === "partnership-listing";
    }

    this.refresh = function() {
        $state.reload().then(function() {
            _this.closeMobileNav();
        });
    };

    this.closeMobileNav = function() {
        angular.element("#mobile-nav").collapse("hide");
        $("#refresh-button").css("display", "none");
    };

    this.autoSelect = function($event) {
        $event.stopPropagation();
        return $event.target.select();
    };

    this.search = function() {
        if ($scope.search.term === "") {
            this.clearSearch();
        }
        else {
            if ($scope.search.section && $scope.search.section.live) {
                $scope.$broadcast("doLiveSearch", $scope.search.term);
            }
            else {
                var state = '.';
                if ($scope.search.section && $state.current !== $scope.search.section.id && $scope.search.term) {
                    state = $scope.search.section.id;
                }
                resetCachedFilter();
                $state.go(state, {
                    search: $scope.search.term,
                    categories: ProductCategoriesService.getFilterIdParameter($scope.selectedCategories)
                });
            }
        }
    };

    this.clearSearch = function() {
        $scope.search.term = undefined;
        if ($scope.search.section && $scope.search.section.live) {
            $scope.$broadcast("doLiveSearch", $scope.search.term);
        }
        else {
            resetCachedFilter();
            delete $stateParams['search'];
            $state.go('.', $stateParams);
        }
    };

    function resetCachedFilter() {
        $scope.cachedFilters = $cookies.getObject("filters");
        if ($scope.cachedFilters && $scope.cachedFilters.hasOwnProperty($state.current.name) && $scope.cachedFilters[$state.current.name].hasOwnProperty('search')) {
            $scope.cachedFilters[$state.current.name]['search'] = undefined;
            $cookies.putObject("filters", $scope.cachedFilters);
        }
    }

    $scope.$on("clearSearch", function() {
        _this.clearSearch();
    });

    this.focusSearchBar = function() {
        angular.element("#SearchBox").focus();
    };

    this.logoutAndRedirect = function(route) {
        UserService.logoutAndRedirect(route);
    };

    this.isFilterAvailable = function() {
        return $scope.search.section && $scope.search.section.hasFilter;
    };

    this.togglePreferredFilter = function() {
        PreferredService.togglePreferred();
    };

    this.togglePromotionFilter = function() {
        PromotionFilterService.togglePromotionFilter();
    };

    this.scanProduct = function() {
        $cordovaBarcodeScanner.scan({
            // Android only
            prompt: gettextCatalog.getString("Place a barcode inside the viewfinder rectangle to scan it.")
        }).then(function(barcodeData) {
            if (!barcodeData.cancelled && barcodeData.format) {
                var stockSection = _.find($scope.searchTypes, function(section) {
                    return section.id === "stocks";
                });
                var invoiceSection = _.find($scope.searchTypes, function(section) {
                    return section.id === "invoiceList";
                });

                if (barcodeData.format === "UPC_A") {
                    if ($scope.search.section && !$scope.search.section.live) {
                        $scope.search.section = stockSection;
                    }
                    $scope.search.term = barcodeData.text.substr(barcodeData.text.length - 12);
                }
                else if (barcodeData.format === "QR_CODE" && invoiceSection) {
                    $scope.search.section = invoiceSection;
                    $scope.search.term = barcodeData.text;
                }
                else {
                    $scope.search.section = stockSection;
                    $scope.search.term = barcodeData.text;
                }
                _this.search();
            }
        }, function(error) {
            console.log("BarCodeError: ");
            console.log(error);
        });
    };

    this.back = function() {
        angular.element("#mobile-nav").collapse("hide");
        $window.history.back();
    };

    function updateElementsFromState(state) {
        if (state.title) {
            $scope.title = state.title(gettextCatalog);
        }

        if (state.defaultSearchSection !== undefined) {
            $scope.search.section = _.find($scope.searchTypes, function(section) {
                return section.id === state.defaultSearchSection;
            });
        }
        else {
            $scope.search.section = $scope.searchTypes[0];
        }

        $scope.backVisible = !state.hideBackButton;
    }

    this.getUserName = function() {
        if ($rootScope.user) {
            if (
                ($rootScope.user.standard_user_customer_count === 1 && !$rootScope.user.global_dedicated_vendor_id)
                || !($rootScope.user.customer && $rootScope.user.customer.name)
                || !$scope.isCustomerTypeBusiness
            ) {
                return $rootScope.user.username;
            }
            else if (
                ($rootScope.user.standard_user_customer_count > 1 || !!$rootScope.user.global_dedicated_vendor_id)
                && $scope.isCustomerTypeBusiness && $rootScope.user.customer && $rootScope.user.customer.name
            ) {
                return $rootScope.user.customer.name;
            }
        }
        else {
            return "";
        }
    };

    this.isCurrentStateAvailable = function() {
        return (
            $state.current.allowsSalesRepUserWithoutCustomerSelected
            && $scope.user && !!$scope.user.global_dedicated_vendor_id
        ) || $state.current.allowsUserWithoutCustomerSelected;
    };

    this.filterSearchFilters = function(value, index, array) {
        if (value.id !== "stocks" && $scope.user && $scope.user.dedicated_user_vendor && $scope.user.dedicated_user_vendor.type === 'vendor_order_manager') {
            return false;
        }

        if (
            value.id === "orderConsolidation"
            && !($scope.user && $scope.user.is_global_order_consolidation)
        ) {
            return false;
        }

        if (
            ($state.current.name !== value.id && $scope.user && !$scope.user.customer && $state.current.allowsSalesRepUserWithoutCustomerSelected)
            || (
                $state.current.name === value.id && $state.current.allowsSalesRepUserWithoutCustomerSelected && $scope.user
                && !$scope.user.customer && !$scope.user.global_dedicated_vendor_id
            )
        ) {
            return false;
        }

        var currentNumbers = $rootScope.CurrentNumbers;
        var hasInvoice = currentNumbers && currentNumbers.has_invoice;
        if ($state.current.name !== "invoiceList" && (value.id === "invoiceList" || value.id === "paymentList") && !hasInvoice) {
            return false;
        }

        var hasGoodsReceipt = currentNumbers && currentNumbers.has_goods_receipt;
        if ($state.current.name !== "goodsReceiptList" && value.id === "goodsReceiptList" && !hasGoodsReceipt) {
            return false;
        }
        if (value.id === "goodsReceiptDetails" && ($state.current.name !== "goodsReceiptDetails" || !hasGoodsReceipt)) {
            return false;
        }
        if (
            $state.current.name !== "goodsTransferList" && value.id === "goodsTransferList"
            && $scope.user && !$scope.user.global_dedicated_vendor_id
        ) {
            return false;
        }
        if ($state.current.name !== "goodsTransferDetails" && value.id === "goodsTransferDetails") {
            return false;
        }
        if ($state.current.name === "customer-listing" && value.id !== "customer-listing" && !$scope.user.customer) {
            return false;
        }
        if (value.id === "customer-listing" && $scope.user.standard_user_customer_count <= 1) {
            return false;
        }
        if ($state.current.name === "partnership-listing" && value.id !== "partnership-listing" && !$scope.user.customer) {
            return false;
        }
        if (value.id === "partnership-listing" && !$scope.user.global_dedicated_vendor_id) {
            return false;
        }

        return true;
    }

    updateElementsFromState($state.current);

    var unregisterFilterCategoryUpdated = $scope.$on("filterCategoryUpdated", function(event, selectedCategories) {
        $state.go($scope.search.section.id, {
            search: $scope.search.term,
            categories: ProductCategoriesService.getFilterIdParameter(selectedCategories)
        });
    });

    var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        updateElementsFromState($state.current);
    });

    var unregisterStateChangeSuccess = $rootScope.$on("$stateChangeSuccess", function(
        event, toState, toParams, fromState, fromParams
    ) {
        updateElementsFromState(toState);

        if (!toParams.categories) {
            $scope.selectedCategories = [];
        }
        if (!toParams.search) {
            _this.clearSearch();
        }
        else {
            $scope.search.term = toParams.search;
        }
    });

    function updateUser(user) {
        if (user) {
            $scope.isGlobalDedicatedVendor = !!user.global_dedicated_vendor_id;
            $scope.isGlobalOrderConsolidation = user.is_global_order_consolidation;
            $scope.defaultEmail = user.email;
            $scope.isUserCanManagePaymentMethods = false;
            $scope.useQuickOrder = false;
            $scope.isCustomerTypeBusiness = true;
            if (user.customer) {
                $scope.isUserCanManagePaymentMethods = user.is_user_can_manage_payment_methods;
                $scope.useQuickOrder = user.info && user.info.customer_use_quick_order;
                $scope.isCustomerTypeBusiness = user.customer.type === CUSTOMER_TYPE["BUSINESS"];
                $scope.msgSupportCreateCustomer = gettextCatalog.getString("To create a new company, please contact support.");
                if (!$scope.isCustomerTypeBusiness) {
                    $scope.msgSupportCreateCustomer = gettextCatalog.getString("To manage another house with the same user account, please contact support.");
                }
                $scope.msgCreateFamilyMemberUser = gettextCatalog.getString("To give access to another family member, please contact support.");
            }
            updateSearchInputMode($scope.search.section.id);
        }
    }

    $scope.$watch("search.section", function(newValue) {
        if (newValue) {
            updateSearchInputMode(newValue.id);
        }
    });

    function updateSearchInputMode(sectionId) {
        if ($scope.useQuickOrder && sectionId === "stocks") {
            $scope.searchInputMode = "decimal";
        }
        else {
            $scope.searchInputMode = "text";
        }
    }

    UserService.isUserFetched().then(function onSuccess(user) {
        updateUser(user);
    });

    var unregisterUserUpdated = $rootScope.$on("UserUpdated", function(event, user) {
        updateUser(user);
    });

    var unregisterUserWithoutCustomerUpdated = $rootScope.$on("UserWithoutCustomerUpdated", function(event, user) {
        updateUser(user);
    });

    $scope.$on("$destroy", function() {
        unregisterLanguageChanged();
        unregisterLanguageChanged = null;

        unregisterStateChangeSuccess();
        unregisterStateChangeSuccess = null;

        unregisterUserUpdated();
        unregisterUserUpdated = null;

        unregisterFilterCategoryUpdated();
        unregisterFilterCategoryUpdated = null;

        unregisterUserWithoutCustomerUpdated();
        unregisterUserWithoutCustomerUpdated = null;
    });
}



//////////////////
// WEBPACK FOOTER
// ./customer/header/header.controller.js
// module id = 786
// module chunks = 0